import { t } from 'ttag';

export const RESEND_SMS_TIMEOUT_SECONDS = 60;
export const IDLE_TIMEOUT_SECONDS = 4;
export const CHECK_STATUS_INTERVAL_SECONDS = 2;
export const MAX_KEP_MULTI_SIGN_DOCUMENTS_COUNT = 250;

export const SIGNATURE_TYPE_LABEL_MAP = {
    signature: t`Підпис`,
    stamp: t`Печатка`,
    rro: t`PPO`,
};

export const PROXY_SERVICE_URL = '/internal-api/proxy/signer';
export const CSIGNER_URL = `${PROXY_SERVICE_URL}?address=${config.CSIGNER_HOST}`;
